/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BonusGrantPlanItem } from './BonusGrantPlanItem';
import {
    BonusGrantPlanItemFromJSON,
    BonusGrantPlanItemFromJSONTyped,
    BonusGrantPlanItemToJSON,
    BonusGrantPlanItemToJSONTyped,
} from './BonusGrantPlanItem';

/**
 * 
 * @export
 * @interface BonusGrantPlanListVo
 */
export interface BonusGrantPlanListVo {
    /**
     * 发放汇总：已发放金额（Σ流水type=1，含一次性+分批）
     * @type {number}
     * @memberof BonusGrantPlanListVo
     */
    grantedTotal?: number;
    /**
     * 发放汇总：待发放金额（Σ进行中计划的待发放批次）
     * @type {number}
     * @memberof BonusGrantPlanListVo
     */
    pendingTotal?: number;
    /**
     * 计划列表
     * @type {Array<BonusGrantPlanItem>}
     * @memberof BonusGrantPlanListVo
     */
    plans?: Array<BonusGrantPlanItem>;
}

/**
 * Check if a given object implements the BonusGrantPlanListVo interface.
 */
export function instanceOfBonusGrantPlanListVo(value: object): value is BonusGrantPlanListVo {
    return true;
}

export function BonusGrantPlanListVoFromJSON(json: any): BonusGrantPlanListVo {
    return BonusGrantPlanListVoFromJSONTyped(json, false);
}

export function BonusGrantPlanListVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BonusGrantPlanListVo {
    if (json == null) {
        return json;
    }
    return {
        
        'grantedTotal': json['grantedTotal'] == null ? undefined : json['grantedTotal'],
        'pendingTotal': json['pendingTotal'] == null ? undefined : json['pendingTotal'],
        'plans': json['plans'] == null ? undefined : ((json['plans'] as Array<any>).map(BonusGrantPlanItemFromJSON)),
    };
}

export function BonusGrantPlanListVoToJSON(json: any): BonusGrantPlanListVo {
    return BonusGrantPlanListVoToJSONTyped(json, false);
}

export function BonusGrantPlanListVoToJSONTyped(value?: BonusGrantPlanListVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'grantedTotal': value['grantedTotal'],
        'pendingTotal': value['pendingTotal'],
        'plans': value['plans'] == null ? undefined : ((value['plans'] as Array<any>).map(BonusGrantPlanItemToJSON)),
    };
}

